import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-display-orders',
    templateUrl: './display-orders.component.html',
    styleUrls: ['./display-orders.component.scss'],
    standalone: false // NOSONAR
})
export class DisplayOrdersComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    public dialogRef: MatDialogRef<DisplayOrdersComponent>
  ) {}
  data: any;
  type: string;
  message: string;
  ngOnInit(): void {
    this.data = this.dataStore.data;
    this.type = this.dataStore.type;
    if (this.type == 'order_number') {   // NOSONAR
      this.message = 'Order Numbers';
    } else if (this.type == 'part_number') {   // NOSONAR
      this.message = 'Part Numbers';
    } else if (this.type == 'kanban_number') {   // NOSONAR
      this.message = 'Kanban Numbers';
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
